<template>
    <form class="max-w-4xl">
        <div class="grid grid-cols-1 gap-x-8 gap-y-6" v-if="item">
            <form-field-text
                id="class-name"
                label="Name"
                field="class_name"
                :value="item.class_name"
                @update="updateClassField"
            ></form-field-text>
            <form-field-text
                id="class-slug"
                label="Slug"
                field="class_slug"
                :value="item.class_slug"
                @update="updateClassField"
            ></form-field-text>
            <form-field-text
                id="class-email"
                label="Email"
                field="class_email"
                :value="item.class_email"
                @update="updateClassField"
            ></form-field-text>
            <form-field-text
                id="class-organiser"
                label="Organiser"
                field="class_organiser"
                :value="item.class_organiser"
                @update="updateClassField"
            ></form-field-text>
            <form-field-text
                id="class-latitude"
                label="Latitude"
                field="class_latitude"
                :value="item.class_latitude"
                @update="updateClassField"
            ></form-field-text>
            <form-field-text
                id="class-longitude"
                label="Longitude"
                field="class_longitude"
                :value="item.class_longitude"
                @update="updateClassField"
            ></form-field-text>
            <form-field-text
                id="class-address"
                label="Address"
                field="class_address"
                :value="item.class_address"
                @update="updateClassField"
            ></form-field-text>
            <form-field-text
                id="class-website"
                label="Website"
                field="class_website"
                :value="item.class_website"
                @update="updateClassField"
            ></form-field-text>
            <form-field-text-rich
                id="class-description"
                label="Description"
                field="class_description"
                :value="item.class_description"
                @update="updateClassField"
            ></form-field-text-rich>
        </div>
        <div class="mt-10">
            <alert-error class="-mt-4 mb-5" :alert="error" :onDismiss="clearError"></alert-error>
            <div class="flex flex-row">
                <button-primary buttonText="Save" :buttonDisabled="disabled" :buttonClick="putClass"></button-primary>
            </div>
        </div>
    </form>
</template>

<script>
import {mapState, mapActions} from 'pinia';

export default {
    name: 'FormClassEdit',
    computed: {
        ...mapState(useStoreClass, {
            item: 'item',
            disabled: 'disabled',
            error: 'error',
        }),
    },
    methods: {
        ...mapActions(useStoreClass, {
            updateClassField: 'updateClassField',
            putClass: 'putClass',
            clearError: 'clearError',
        }),
    },
};
</script>
